import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0decefea&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0decefea')) {
      api.createRecord('0decefea', component.options)
    } else {
      api.reload('0decefea', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=0decefea&", function () {
      api.rerender('0decefea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/App.vue"
export default component.exports